import { useState } from "react";
import { toast } from "sonner";
import { Camera, CheckCircle2, ImageIcon } from "lucide-react";
import api, { formatApiError, API } from "../lib/api";

export default function DeliveryProofPanel({ order, isWinner, onReload }) {
  const [busy, setBusy] = useState(false);
  const proofs = order.delivery_proofs || [];
  if (!["paid", "delivered"].includes(order.status)) return null;
  const canUpload = isWinner && order.status !== "delivered" ? true : isWinner && order.confirmation_status !== "confirmed" && order.confirmation_status !== "auto_confirmed";
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      await api.post(`/orders/${order.id}/delivery-proof`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Bolla firmata caricata come prova di consegna");
      onReload?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  if (!isWinner && proofs.length === 0) return null;
  return (
    <div className="mt-3 p-3 rounded-xl border border-slate-200 bg-slate-50 text-sm" data-testid="delivery-proof-panel">
      <div className="text-xs font-mono uppercase tracking-widest text-slate-600 flex items-center gap-1.5"><Camera className="w-3 h-3" /> Prova di consegna · bolla firmata</div>
      {proofs.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2" data-testid="delivery-proof-list">
          {proofs.map((p, i) => (
            <a key={i} href={`${API}/files/${p.path}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-800 px-2.5 py-1 text-xs font-semibold hover:bg-emerald-200" data-testid={`delivery-proof-${i}`}>
              <CheckCircle2 className="w-3 h-3" /> Foto {i + 1} · {new Date(p.uploaded_at).toLocaleString("it-IT")}
            </a>
          ))}
        </div>
      )}
      {isWinner && canUpload && proofs.length < 3 && (
        <label className={`mt-2 flex items-center justify-center gap-2 rounded-full border border-dashed border-slate-400 px-3 py-2 text-xs font-semibold text-slate-700 cursor-pointer hover:bg-white ${busy ? "opacity-60 pointer-events-none" : ""}`} data-testid="delivery-proof-upload-label">
          <ImageIcon className="w-4 h-4" /> {busy ? "Caricamento..." : proofs.length ? "Aggiungi un'altra foto" : "Carica foto della bolla firmata"}
          <input type="file" accept="image/jpeg,image/png,image/webp" capture="environment" className="hidden" onChange={e => upload(e.target.files?.[0])} data-testid="delivery-proof-input" />
        </label>
      )}
      {isWinner && <div className="mt-1.5 text-[11px] text-slate-500">Scatta la foto della bolla con la firma dell'acquirente: in caso di contestazione sarà la tua prova per l'amministratore. Max 3 foto, 5 MB.</div>}
    </div>
  );
}
